import { KeyboardArrowDown, KeyboardArrowRight } from "@mui/icons-material";
import React, { useState } from "react";
import { Alert, Box, Button, IconButton, TableBody, TableHead, TableRow, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import { api } from "../../../../shared/hooks/api";
import { StyledTable, StyledTableCell, TableContainer } from "../../../../shared/components/CustomTable/Styled";
import { formatInternationalNumber } from "../../../../utils/format";

interface Balance {
    exported_quantity: number;
    source_consumed_quantity: number;
    provider_holding_quantity: number;
}
interface SourceBalance extends Balance {
    material: { id: string; material_code: string; name: string; measurement_unit: string; storage: string };
    orders: (Balance & { id: string; name: string; created_at: string })[];
}
const headings = ["Vật tư nguồn", "Đơn vị", "Kho", "Số đơn", "Đã xuất", "Đã tiêu hao quy đổi", "Nhà gia công còn giữ"];
const Metrics = ({ value }: { value: Balance }) => <>
    <StyledTableCell align="right">{formatInternationalNumber(value.exported_quantity)}</StyledTableCell>
    <StyledTableCell align="right">{formatInternationalNumber(value.source_consumed_quantity)}</StyledTableCell>
    <StyledTableCell align="right">{formatInternationalNumber(value.provider_holding_quantity)}</StyledTableCell>
</>;
export default function OutsourceTracking({ providerId }: { providerId: string }) {
    const [{ data, isLoading, error }, reload] = api.get<SourceBalance[]>(`/materials/providers/${providerId}/outsource-tracking/`);
    const [expanded, setExpanded] = useState<string[]>([]);
    const toggle = (id: string) => setExpanded(current => current.includes(id) ? current.filter(value => value !== id) : [...current, id]);
    if (isLoading) return <Typography role="status">Đang tải theo dõi gia công...</Typography>;
    if (error) return <Alert severity="error" action={<Button onClick={() => reload()}>Thử lại</Button>}>Không tải được theo dõi gia công.</Alert>;
    if (!data?.length) return <Typography>Chưa có vật tư nguồn trong các đơn gia công của nhà cung cấp này.</Typography>;
    return <TableContainer><StyledTable aria-label="Theo dõi gia công" sx={{ minWidth: 900, "& .MuiTableCell-root": { minWidth: 0 }, "& .MuiTableCell-root:first-of-type": { minWidth: 180 } }}><TableHead><TableRow>
        {headings.map((heading, index) => <StyledTableCell key={heading} align={index >= 3 ? "right" : "left"}>{heading}</StyledTableCell>)}
    </TableRow></TableHead><TableBody>
        {data.map((row: SourceBalance) => <React.Fragment key={row.material.id}>
            <TableRow hover onClick={() => toggle(row.material.id)} sx={{ cursor: "pointer" }}>
                <StyledTableCell>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, py: 0.5 }}>
                        <IconButton size="small" onClick={event => { event.stopPropagation(); toggle(row.material.id); }}
                            aria-expanded={expanded.includes(row.material.id)} aria-label={`Các đơn gia công của ${row.material.name}`}
                            sx={{ width: 28, height: 28, flexShrink: 0, border: 0, borderRadius: 1, color: "text.secondary" }}>
                            {expanded.includes(row.material.id) ? <KeyboardArrowDown fontSize="small" /> : <KeyboardArrowRight fontSize="small" />}
                        </IconButton>
                        <Box sx={{ minWidth: 0, lineHeight: "20px" }}>
                            <Box component="span" sx={{ fontWeight: 600 }}>{row.material.material_code}</Box>
                            <Box sx={{ color: "text.secondary", overflowWrap: "anywhere" }}>{row.material.name}</Box>
                        </Box>
                    </Box>
                </StyledTableCell>
                <StyledTableCell>{row.material.measurement_unit}</StyledTableCell>
                <StyledTableCell>{row.material.storage}</StyledTableCell>
                <StyledTableCell align="right">{row.orders.length}</StyledTableCell>
                <Metrics value={row} />
            </TableRow>
            {expanded.includes(row.material.id) && row.orders.map(order => <TableRow key={order.id}>
                <StyledTableCell sx={{ pl: "44px !important" }}><Link to={`/outsource-orders/${order.id}`}>{order.name}</Link></StyledTableCell>
                <StyledTableCell colSpan={3}>Ngày tạo: {dayjs(order.created_at).format("DD/MM/YYYY")}</StyledTableCell>
                <Metrics value={order} />
            </TableRow>)}
        </React.Fragment>)}
    </TableBody></StyledTable></TableContainer>;
}
